import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import appConfig from 'app-config';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { MLCapitalizeStringFilter } from 'ml-portals-util-js';
import metadata from './MLEmployersAffiliationsSummaryComponent.metadata.json5';
import styles from './MLEmployersAffiliationsSummaryComponent.module.scss';
import messages from './MLEmployersAffiliationsSummaryComponent.messages';

function MLEmployersAffiliationsSummaryComponent(props) {
    const isQB = appConfig.portalCode === 'QB';
    const isGPA = appConfig.portalCode === 'GPA';
    const { model, employerNotListed, showErrors,  isEndorsement} = props;
    const paypointCommentsConsumer = _.get(model, 'paypointCommentsConsumer.value', '');
    const paypointEligibilityComments = _.get(model, 'paypointEligibilityComments.value', '')
    const translator = useTranslator();
    const companyComments = (isGPA) ? _.get(model, 'companyARSPrompt.value', '') : _.get(model, 'companyConsumerFacingComments.value', '');

    const overrides = {
        paypointEligibilityComments: {
            visible: isQB ? false : paypointEligibilityComments.length > 0 && isGPA,
            content: translator(messages.paypointEligibilityComments,
                { paypointEligibilityComments })
        },
        paypointCommentsConsumer: {
            visible: isQB ? false : paypointCommentsConsumer.length > 0 && !isGPA,
            content: translator(messages.paypointEligibilityCommentsConsumer,
                { paypointCommentsConsumer })
        },
        companyComments: {
            visible: isQB ? false : companyComments.length > 0,
            content: companyComments
        },
        validEmployerContainer: {
            visible: !employerNotListed
        },
        employerNotListedMessage: {
            visible: employerNotListed
        },
        companyName: {
            value: MLCapitalizeStringFilter.capitalize(_.get(model, 'companyName.value', '')) 
        },
        organizationName: {
            visible: !isQB,
            content: translator(messages.organizationName,
                { organizationName: MLCapitalizeStringFilter.capitalize(_.get(model, 'accountName.value', '')) })
        },
        paypointName: {
            visible: isQB || isEndorsement,
            content: translator(messages.paypointName,
                { paypointName: MLCapitalizeStringFilter.capitalize(_.get(model, 'paypointName.value', '')) })
        },
        gpcCode: {
            content: translator(messages.gpcCode,
                { gpcCode: _.get(model, 'gpcCode.value', '') })
        },
        payPeriod: {
            content: translator(messages.payPeriod,
                { payPeriod: _.get(model, 'payPeriod.value', '') })
        },
        paypointNumber: {            
            visible: !isQB,
            content: translator(messages.paypointNumber,
                { paypointNumber: _.get(model, 'paypointNumber.value', '') })
        }
    };


    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={model}
            classNameMap={styles}
            overrideProps={overrides}
            showErrors={showErrors}
        />
    );
}

MLEmployersAffiliationsSummaryComponent.propTypes = {
    model: PropTypes.shape({
        accountName: PropTypes.string,
        gpcCode: PropTypes.string,
        payPeriod: PropTypes.string,
        paypointNumber: PropTypes.string
    }).isRequired,
    employerNotListed: PropTypes.bool
};

MLEmployersAffiliationsSummaryComponent.defaultProps = {
    employerNotListed: false
};

export default MLEmployersAffiliationsSummaryComponent;
